import styles from "./PageSubTitle.module.scss";
import PageSubTitleType from "./PageSubTitleType";

const PageSubTitle = (props: PageSubTitleType) => {
  const {id,text,commonClass} = props;
  return (
    <>
      <div className={`${styles.PageSubTitle}`} id={id}>
        {text}
      </div>
    </>
  )
}
export default PageSubTitle;